// extracted by mini-css-extract-plugin
export var counters = "timelineCounters-module--counters--J0Hwt";
export var counterItem = "timelineCounters-module--counterItem---cYnw";
export var label = "timelineCounters-module--label--9pKDb";
export var bombCount = "timelineCounters-module--bombCount--Rstcg";
export var numCounter = "timelineCounters-module--numCounter--FERNz";
export var counterSlide = "timelineCounters-module--counterSlide--6W3cI";
export var slideUp = "timelineCounters-module--slideUp--gcJVA";
export var slideUpLarge = "timelineCounters-module--slideUpLarge--n+TY3";